import React, { Component } from 'react';
import { Switch } from 'react-router';
import { AdminRoute } from '../AdminRoute';
import Layout from './Layout';
import CategoryThemeView from '../CategoryView/CategoryThemeView';
import ThemePackagesView from '../CategoryView/ThemePackagesView';
import ThemePackageView from '../CategoryView/ThemePackageView';

export default class DashboardView extends Component {
    render() {
        return (
            <Layout>
                <Switch>
                    <AdminRoute path='/dashboard/themes/:id/concept/:code' component={(props) => (
                        <CategoryThemeView {...props} />
                    )}
                    />
                    <AdminRoute path='/dashboard/themes/:id' component={(props) => (
                        <ThemePackageView {...props} />
                    )}
                    />
                    <AdminRoute path='/dashboard/themes' component={(props) => (
                        <ThemePackagesView {...props} />
                    )}
                    />
                </Switch>
            </Layout>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardView.js